module.exports = __webpack_public_path__ + "img/IMG_0328_L_BlackMatted.532e99a9.jpg";